<template>
  <section id="form-quote-tiers" class="rel quote-tiers-section division">
    <v-form name="requestForm" ref="requestForm" class="contact-form">
      <v-item-group selected-class="bg-primary" v-model="selection">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-card 
                class="mx-auto align-items-center border-shadow-card" 
                max-width="600"
              >
                <v-toolbar>
                  <elements-form-navigate-back @goBack="goBack" />
                  <v-toolbar-title class="text-h5 custom-toolbar-title">
                    {{ formTitle }}
                  </v-toolbar-title>
                </v-toolbar>
                <v-divider class="mt-0"/>
                <v-card-text>
                  <v-radio-group 
                    class="mt-0" 
                    v-model="selection" 
                    :rules="requiredRules"
                    hide-details="auto">
                    <v-item
                      v-for="(item, i) in tiers"
                      v-slot="{ isSelected, toggle }"
                      :key="`list-item-${item.key}`"
                    >
                      <v-card
                        :variant="isSelected ? 'tonal' : 'flat'"
                        class="align-center mb-5"
                        dark
                        border
                        flat
                        @click="toggle"
                      >
                        <v-list-item
                          min-height="80"
                        >
                          <div class="subtitle-1 font-weight-medium">{{ item.name }}</div>
                          <div class="body- font-weight-light">{{ item.description }}</div>
                          <template v-slot:prepend>
                            <v-radio
                              :value="i"
                              :data-name="`tier-radio-${i}`"
                              hide-details="auto"
                              readonly
                            >
                            </v-radio>
                          </template>

                          <template v-slot:append>
                            <v-avatar>
                              <v-icon>{{ item.icon }}</v-icon>
                            </v-avatar>
                          </template>
                        </v-list-item>
                      </v-card>
                    </v-item>
                  </v-radio-group>
                </v-card-text>
                <v-divider class="mb-0"/>
                <v-card-actions class="d-flex justify-end color--white my-1">
                  <v-btn
                    variant="flat"
                    size="large"
                    light
                    @click="submitForm"
                  >
                  Continue
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-item-group>
    </v-form>
  </section>
</template>

<script lang="ts">
export default defineComponent({
  name: "ComponentsFormsQuoteTiers",
  props: {
    formTitle: {
      type: String as () => string,
      default: () => "Choose who you would like to cover",
    },
    stepId: {
      type: String as () => string,
      default: () => "STEP02",
    },
  },
  setup(props: any) {
    const { stepId } = props
    const quotePayload = ref<QuotePayload>(useQuotePayload().quotePayload.value);
    const quotePayloadStore = storeToRefs(useQuotePayloadStore()).quotePayload.value;
    if(!_isEmpty(quotePayloadStore)) {
      quotePayload.value = quotePayloadStore;
    }

    const tiers = ref<Tier[]>([
      {
        key: "Individual",
        name: "Primary Insured",
        description: "Coverage for one individual",
        icon: "mdi-account",
      },
      {
        key: "IndividualSpouse",
        name: "Primary Insured + Spouse",
        description: "Coverage for an individual and spouse/partner",
        icon: "mdi-account-multiple",
      },
      {
        key: "IndividualChild",
        name: "Primary Insured + Children",
        description: "Coverage for an individual and children",
        icon: "mdi-account-multiple",
      },
      {
        key: "Family",
        name: "Family",
        description: "Coverage for an individual, spouse and children",
        icon: "mdi-account-group",
      },
    ]);
    const requiredRules = [
      (v: any) => v >= 0 || 'Coverage is required'
    ];

    const requestForm = ref();
    const submitForm = async () => {
      const { valid } = await _get(requestForm, "value", "").validate();
      if(valid) {
        useQuotePayloadStore().setQuotePayloadValue(quotePayload.value);
        //UPDATE CONTACT INFO - START
        const contactInfo = ref<ContactInfo>(useContactInfo().contactInfo.value);
        const contactInfoStore = storeToRefs(useContactInfoStore()).contactInfo.value
        if (!_isEmpty(contactInfoStore)) {
          contactInfo.value = contactInfoStore
        }
        setDeepValue(contactInfo.value, 'properties.coverage_choice', useQuotePayloadStore().insuredOptionApplicationValue)
        useContactInfoStore().setContactInfoValue(contactInfo.value)
        try{
          await useContactInfo().putContactInfo(stepId)
        } catch(err) {
          console.error("updateContactInfo-error: ", err)
        }
        //UPDATE CONTACT INFO - END
        return navigateTo({ path: "/forms/quote/review" });
      }
    };
    const goBack = () => {
      return navigateTo({ path: "/forms/quote/start" });
    };
    
    const selection = ref() //tiers.value.findIndex((tier: Tier) => tier.key === quotePayload.value.primaryInsured.coverages[0].options.insuredOption.applicationValue));
    watch(selection, (newValue: number) => {
      type ApplicationValue = "Individual" | "IndividualSpouse" | "IndividualChild" | "Family" | null | undefined;
      let value: string = tiers.value[newValue]?.key;
      let baseCoverage = quotePayload.value.primaryInsured.coverages.find((coverage: Coverage) => coverage.coverageLookup === "Base");
      if(baseCoverage) {
        setDeepValue(baseCoverage, 'options.insuredOption.applicationValue', value as ApplicationValue);
      }
    },
    {
      immediate: true
    });

    return {
      tiers,
      requiredRules,
      requestForm,
      submitForm,
      goBack,
      quotePayload,
      selection
    };
  },
});
</script>
